
import { useState } from "react";
import Loader from "../../components/Loader/Loader";
import logoLg from "../../assets/images/lg-logo.png";
import crossBtn from "../../assets/images/clear.png";
import { Link } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { withRouter, notification, emailRegex } from "../../utils/utility";
import { connect } from "react-redux";
import { sendPostRequest } from "../../actions/app-actions";

const ForgotPassword = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    const Schema = Yup.object().shape({
        email: Yup.string()
        .matches(emailRegex, "Please enter valid email")
        .required("Email cannot be empty")
    });

    const formikProps = {
        initialValues: {
          email: "",
        },
        validationSchema: Schema,
        onSubmit: (values, formikHelpers) => {
            const data = {
                email: values.email
            };
            setIsLoading(true);
            props.sendPostRequest({
                url: `/forgot-password`,
                data,
                onSuccess: function (response) {
                    if (response.success) {
                        notification.success(response.message);
                        setIsSubmitDisabled(true);
                    }
                    setIsLoading(false);
                },
                onError: function (error) {
                    const { data } = error.response;
                    if (!data.success) {
                        if (!Array.isArray(data.message)) {
                            notification.error(data.message);
                            formikHelpers.setFieldError(
                                "email",
                                data.message
                            );
                        }
                    }

                    console.log('error', error);

                    setIsLoading(false);
                },
            });
        },
    };

    return (
        <>
            <Loader isShowLoader={isLoading} />
            <Formik {...formikProps}>
                {(formik) => {
                    const { values, handleChange, handleSubmit, handleBlur } = formik;
                    return (
                        <div className="signup-process">
                            <div className="logo-side">
                                <img src={logoLg} alt="" />
                            </div>
                            <div className="signup">
                                <div className="cross-btn">
                                    <Link to="/">
                                        <img width="33" src={crossBtn} alt="" />
                                    </Link>
                                </div>
                                <div className="signup-form">
                                    <form onSubmit={handleSubmit}>
                                        <h1 className="mb-2">Forgot Password</h1>
                                        <p className="r-p">Please enter your email address.</p>
                                        <p className="r-p">You will receive a link to create a new password via email.</p>
                                        <div className="form-group mb-0">
                                        <label className="same-label" htmlFor="email">
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            className="form-control same-input"
                                            name="email"
                                            id="email"
                                            placeholder="Enter Email"
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        </div>
                                        <ErrorMessage
                                        name="email"
                                        render={(error) => <span className="error">{error}</span>}
                                        />
                                        <button type="submit" className="btn btn-app" disabled={isSubmitDisabled}>
                                            Send Password Reset Link
                                        </button>
                                        <p className="login-here">
                                            Don't have a account? <Link to="/signup">SignUp Now</Link>
                                        </p>
                                    </form>
                                </div>
                                <div className="signup-footer">
                                    <ul className="languages d-none">
                                        <li>English (UK)</li>
                                        <li>हिन्दी</li>
                                        <li>ਪੰਜਾਬੀ</li>
                                        <li>বাংলা</li>
                                        <li>Deutsch</li>
                                        <li>ગુજરાતી</li>
                                        <li>Español</li>
                                    </ul>
                                    <p>Copyright © 2025 MeetOcto.</p>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Formik>
        </>
    );
}

export default connect(null, { sendPostRequest  })(withRouter(ForgotPassword));